// extracted by mini-css-extract-plugin
export var avatarContainer = "_73-0";
export var avatarTypingWave = "_73-i";
export var gray = "_73-f";
export var green = "_73-c";
export var icon = "_73-9";
export var image = "_73-1";
export var lg = "_73-6";
export var md = "_73-5";
export var presenceDot = "_73-b";
export var red = "_73-d";
export var sm = "_73-4";
export var status = "_73-a";
export var typingDot = "_73-h";
export var typingPill = "_73-g";
export var xl = "_73-7";
export var xs = "_73-3";
export var xxl = "_73-8";
export var xxs = "_73-2";
export var yellow = "_73-e";